import React from "react";
import { FaFacebookF, FaInstagram, FaLinkedinIn, FaWhatsapp, FaYoutube } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import { useSelector } from "react-redux";

const socialIconMap = {
  facebook: { Icon: FaFacebookF, color: "#1877F2", label: "Facebook" },
  instagram: { Icon: FaInstagram, color: "#E4405F", label: "Instagram" },
  twitter: { Icon: FaXTwitter, color: "#111827", label: "X" },
  x: { Icon: FaXTwitter, color: "#111827", label: "X" },
  youtube: { Icon: FaYoutube, color: "#FF0000", label: "YouTube" },
  linkedin: { Icon: FaLinkedinIn, color: "#0A66C2", label: "LinkedIn" },
  whatsapp: { Icon: FaWhatsapp, color: "#25D366", label: "WhatsApp" }
};

const normalizeUrl = (value = "") => (
  value.startsWith("http://") || value.startsWith("https://")
    ? value
    : `https://${value}`
);

const SocialIcons = () => {
  const company = useSelector((state) => state.companyReducer.company);
  const socialMediaLinks = {};

  if (company?.socialMediaAccounts) {
    company.socialMediaAccounts.forEach((account) => {
      if (account.value) {
        socialMediaLinks[String(account.name || "").toLowerCase()] = normalizeUrl(account.value);
      }
    });
  }

  return (
    <div className="flex gap-2">
      {Object.entries(socialMediaLinks).map(([name, href]) => {
        const config = socialIconMap[name];
        if (!config) return null;
        const { Icon, color, label } = config;

        return (
          <a
            key={name}
            aria-label={label}
            className="inline-flex h-9 w-9 items-center justify-center rounded-full transition hover:bg-slate-100 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-slate-300"
            href={href}
            rel="noopener noreferrer"
            target="_blank"
            title={label}
          >
            <Icon aria-hidden="true" style={{ color }} size={18} />
          </a>
        );
      })}
    </div>
  );
};

export default SocialIcons;
